// The pacing of the finish. The house rule (every game here): a payoff is
// paced, never dumped - the theme entries light up one by one, with a beat
// each, before the sheet names the theme. All display-only, all skippable,
// and `prefers-reduced-motion` collapses it to zero.
export const THEME_STEP_MS = 650;
export const THEME_LEAD_MS = 400;
export const SHEET_HOLD_MS = 1100;
// A Giant has thirty-odd theme entries: a quicker beat each.
export const GIANT_STEP_MS = 320;

export function revealPlan(themeEntries, reduced = false, stepMs = THEME_STEP_MS) {
  if (reduced) return { steps: new Array(themeEntries).fill(0), sheetAt: 0 };
  const steps = [];
  for (let i = 0; i < themeEntries; i += 1) steps.push(THEME_LEAD_MS + i * stepMs);
  const last = steps.length ? steps[steps.length - 1] : 0;
  return { steps, sheetAt: last + SHEET_HOLD_MS };
}

export function reduceMotion() {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
